function fetchConfig(type = 'json') {
  var contentType = 'application/' + type;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: contentType,
    },
  };
}
function getCookieByProduct(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}
window._AutofillCallbackHandler =
  window._AutofillCallbackHandler || function () {};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      //const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      //buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach(
      (button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        const elementLink = summaryElement.querySelector('a[href]')
        if(!elementLink){
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
        }
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent && elementToFocus)
      elementToFocus.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`,
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    if (element) {
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true')
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener(
        'click',
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === 'next' && !isLastSlide) ||
      (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
let selectedOptions = [];

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.addEventListener('change', this.rebuildOptions);
    this.rebuildOptions();
  }
  rebuildOptions() {
    const pickerType = document.querySelector('variant-radios')
      ? 'radios'
      : 'selects';
    const variantSelects =
      pickerType == 'radios'
        ? document.querySelector('variant-radios')
        : document.querySelector('variant-selects');
    if (!variantSelects) {
      return;
    }
    const fieldsets =
      pickerType == 'radios'
        ? Array.from(variantSelects.querySelectorAll('fieldset'))
        : Array.from(
            variantSelects.querySelectorAll('.product-form__input--dropdown'),
          );
    selectedOptions = fieldsets.map((fieldset) => {
      return pickerType == 'radios'
        ? Array.from(fieldset.querySelectorAll('input')).find(
            (radio) => radio.checked,
          ).value
        : Array.from(
            fieldset.querySelectorAll('select'),
            (select) => select.value,
          );
    });

    //loop through the option sets starting from the 2nd set and disable any invalid options
    for (
      let optionLevel = 1, n = fieldsets.length;
      optionLevel < n;
      optionLevel++
    ) {
      const inputs =
        pickerType == 'radios'
          ? fieldsets[optionLevel].querySelectorAll('input')
          : fieldsets[optionLevel].querySelectorAll('option');

      inputs.forEach((input) => {
        input.disabled = this.validCombo(input.value, optionLevel)
          ? false
          : true;
        if (pickerType == 'radios') {
          const label = fieldsets[optionLevel].querySelector(
            `label[for="${input.id}"]`,
          );

          label.style.display = input.disabled ? 'none' : '';

          input.hidden = this.validCombo(input.value, optionLevel)
            ? false
            : true;
        }
      });
    }

    for (
      let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      if (pickerType == 'radios') {
        if (
          fieldsets[optionLevel].querySelector('input:checked').disabled ===
          true
        ) {
          if (fieldsets[optionLevel].querySelector('input:not(:disabled)')) {
            const inputHidden = fieldsets[optionLevel].querySelector(
              'input[checked][disabled]',
            );
            if (inputHidden) {
              inputHidden.removeAttribute('checked');
            }
            const input = fieldsets[optionLevel].querySelector(
              'input:not(:disabled)',
            );
            input.checked = true;
            //this.onVariantChange()
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            input.dispatchEvent(evt);
            change = input;
          }
        }
      } else {
        if (
          fieldsets[optionLevel].querySelector('option:checked').disabled ===
          true
        ) {
          change = fieldsets[optionLevel].querySelector(
            'option:not(:disabled)',
          ).selected = 'selected';
        }
      }
      //if a new option has been selected, restart the whole process
      if (change)
        variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  validCombo(inputValue, optionLevel) {
    const pickerType = document.querySelector('variant-radios')
      ? 'radios'
      : 'selects';
    const variantSelects =
      pickerType == 'radios'
        ? document.querySelector('variant-radios')
        : document.querySelector('variant-selects');
    const productJson = JSON.parse(
      variantSelects.querySelector('[type="application/json"]').textContent,
    );

    const typeProduct = document.querySelector('#product_type').textContent;
    const styles = ['Classic Tee', 'Sweater', 'Pullover Hoodie'];
    const country = getCookieByProduct('code_country');
    const colorSand = 'Sand';
    const colorFilter = ['Sport Grey', 'White', 'Black'];
    const sizeFilter = ['4XL', '5XL'];
    const sizeCanvas = ['24" x 36"', '36" x 24"'];
    const typeCanvas = 'Canvas';
    const sizePoster = ['11"x14"', '14"x11"', '8"x12"', '12"x8"'];
    const typePoster = 'Poster';
    const sizeCard = ['5" x 7"', '7" x 5"'];
    const pack = '1 Card';
    const typeProductEmbroidered = 'Embroidered Shirt';

    if (country == 'US' || typeProduct == typeProductEmbroidered) {
      return true;
    }

    for (let i = 0; i < productJson.length; i++) {
      if (optionLevel == 1) {
        if (
          colorSand == inputValue ||
          (typeCanvas == selectedOptions[0] &&
            sizeCanvas.includes(inputValue.replace(/\s/g, ''))) ||
          (typePoster == selectedOptions[0] &&
            sizePoster.includes(inputValue.replace(/\s/g, ''))) ||
          (sizeCard.includes(selectedOptions[0]) && pack == inputValue)
        ) {
          return false;
        }
      } else if (optionLevel == 2) {
        if (
          styles.includes(selectedOptions[0]) &&
          !colorFilter.includes(selectedOptions[1]) &&
          sizeFilter.includes(inputValue)
        ) {
          return false;
        }
      }
    }

    return true;
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    const campShirt = document.querySelector(
      '#product_type[data-type="Shirt"]',
    );
    if (campShirt && showDateCutOff) {
      const codeCountry = getCookieByProduct('code_country') || 'US';
      loadDateCutOff(codeCountry);
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    var formatCurrency = $('body').data('money-format');

    if (this.currentVariant) {
      /*const money = Shopify.formatMoney(
        this.currentVariant.price,
        formatCurrency
      );*/
      return;
    }

    if (!this.currentVariant && this.options.length == 3) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return (
          variant.options[0] === this.options[0] &&
          variant.options[1] === this.options[1]
        );
      });

      if (!this.currentVariant) {
        this.currentVariant = this.getVariantData().find((variant) => {
          return variant.options[0] === this.options[0];
        });
      }
      if (this.currentVariant) {
        const option2 = document.querySelector(
          `input[value='${this.currentVariant.option2}']`,
        );
        if (option2) option2.checked = true;
      }
    }

    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.options[0] === this.options[0];
      });
    }

    if (this.options.length == 3) {
      if (this.currentVariant) {
        document.querySelector(
          `input[value='${this.currentVariant.option3}']`,
        ).checked = true;
      }
    }

    if (this.options.length == 2) {
      document.querySelector(
        `input[value="${this.currentVariant.option1}"]`,
      ).checked = true;

      document.querySelector(
        `input[value='${this.currentVariant.option2}']`,
      ).checked = true;
    }

    /*const money = Shopify.formatMoney(
      this.currentVariant.price,
      formatCurrency
    );*/

    this.options = this.updateOptions();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) => {
      if (mediaGallery.setActiveMedia) {
        return mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true,
        );
      }
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      pickUpAvailability.fetchAvailability
    ) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && productForm.handleErrorMessage)
      productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const variantSelects = html.querySelector('variant-selects');
        if(variantSelects){
          const variantSelectOld = document.querySelector('variant-selects');
          variantSelectOld.innerHTML = variantSelects.innerHTML
        }
        const variantBundles = html.getElementById('variant-bundles');
        const variantTeddyBear = html.getElementById('variant-teddyBear');
        const mutiplateBox = html.getElementById('mutiplate-size-box');
        // update UI Pack 
        const mutiplatePack = html.getElementById('mutiplate-pack-options');
        if(mutiplatePack){
          const mutiplatePackOld = document.querySelector('variant-radios.no-js-hidden');
          const mutiplatePackNew = html.querySelector('variant-radios.no-js-hidden');
          if(mutiplatePackOld && mutiplatePackNew){
            mutiplatePackOld.innerHTML = mutiplatePackNew.innerHTML
          }
        }
        if (variantBundles || variantTeddyBear || mutiplateBox) {
          const formGiftBox = document.getElementById('form-addon1');
          const giftBox = document.querySelector('.gift-box.box');
          if (formGiftBox && giftBox) {
            formGiftBox.innerHTML =
              html.getElementById('form-addon1')?.innerHTML;
            giftBox.innerHTML = html.querySelector('.gift-box.box')?.innerHTML;
          }
        }
        // default qty box buy pack
          const pack = html.querySelector('.qty_default_box');
          const qty_box = document.querySelector('[name="quantity-box"]')

          if(pack && pack.innerText && qty_box){
            qty_box.value = parseInt(pack.innerText)
          }
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`,
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`,
        );

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination)
          volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'hidden',
            skuSource.classList.contains('hidden'),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden'),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'hidden',
            inventorySource.innerText === '',
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );
        // const currency = getCookieByProduct("currency");
        // if (Currency && currency) {
        //   Currency.convertAll(
        //     "USD",
        //     currency,
        //     ".money",
        //     "money_with_currency_format"
        //   );
        // }
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

var elementsShipping = document.querySelectorAll(
  '.deliver-to-country-line, .selected-coutry, #box-shipping',
);

elementsShipping.forEach(function (element) {
  element.addEventListener('click', function () {
    var popupShippingCountryElement = document.querySelector(
      '.popup-shipping-country',
    );
    var currency = getCookieByProduct('currency') || 'USD';
    var selectCurrency = document.querySelector(
      '#currencies-country .currencies-country',
    );
    if (selectCurrency) {
      selectCurrency.value = currency;
    }
    var bgCountryElement = document.querySelector('.bg-country');

    popupShippingCountryElement.classList.toggle('hidden');
    bgCountryElement.classList.toggle('hidden');
  });
});

var closedShipping = document.querySelectorAll(
  '.bg-country,.img-closed-popup-shipping',
);

closedShipping.forEach(function (element) {
  element.addEventListener('click', function () {
    var popupShippingCountryElement = document.querySelector(
      '.popup-shipping-country',
    );
    var bgCountryElement = document.querySelector('.bg-country');

    popupShippingCountryElement.classList.toggle('hidden');
    bgCountryElement.classList.toggle('hidden');
  });
});

$(document).ready(function () {
  var currency = $('.currencies').val();
  if (currency === 'USD') {
    $('#pp-pay-later-message-desktop').show();
    $('#pp-pay-later-message').show();
  } else {
    $('#pp-pay-later-message-desktop').hide();
    $('#pp-pay-later-message').hide();
  }
});
$('body').on('change', '.currencies', function (e) {
  var currency = $(this).val();
  if (currency === 'USD') {
    $('#pp-pay-later-message-desktop').show();
    $('#pp-pay-later-message').show();
  } else {
    $('#pp-pay-later-message-desktop').hide();
    $('#pp-pay-later-message').hide();
  }
});
function generateFileAuth(apiKey) {
  if (!engraver) {
    alert('not support');
    return;
  }
  if (!engraver.currentProduct) {
    alert('no select currentProduct');
    return;
  }
  var texts = engraver.textObjects.map(function (t) {
      return {
        id: t.id,
        uuid: t.uuid,
        textValue: t.clText || t.getText(),
        colorOption: t.selectedColorId || 1,
        colorHex: t.selectedColorHex,
        fontId: t.selectedFont || 1,
      };
    }),
    circularsText = engraver.circularTextObjects.map(function (t) {
      return {
        id: t.id,
        uuid: t.uuid,
        textValue: t.clText || t.text,
        colorOption: t.selectedColorId || 1,
        colorHex: t.selectedColorHex,
        fontId: t.selectedFont || 1,
      };
    });
  var vectorObjects = engraver.vectorEPSObjects
      .filter(function (t) {
        return !t.allowUserUpload;
      })
      .map(function (t) {
        return {
          id: t.id,
          uuid: t.uuid,
          position: t.selectedVectorIndex,
          realPosition:
            t.vectorLibraryId || t.hasLibrary
              ? t.selectedVectorIndex
              : t.selectedVectorIndex + 1,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
        };
      }),
    imagesParameters = engraver.imageHolderObjects.map(function (t) {
      var e = '';
      return (
        (e =
          t.hasStaticImage || t.dynamicImagesPath
            ? t.id + '-serverStoredImage'
            : t.imageName),
        {
          id: t.id,
          isStaticImage: !!t.hasStaticImage,
          fileName: e,
          uuid: t.uuid,
          position: t.selectedImageIndex,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
          offsetX: t.getEditModeImageParameters().offsetX,
          offsetY: t.getEditModeImageParameters().offsetY,
          previewOriginalElementWidth: t.originalElement.width,
          previewOriginalElementHeight: t.originalElement.height,
          angle: t.getEditModeImageParameters().angle,
          maskScaleX: t.getEditModeImageParameters().scaleX,
          maskScaleY: t.getEditModeImageParameters().scaleY,
          threshold: t.threshold,
        }
      );
    }),
    vectorsParameters = engraver.vectorEPSObjects
      .filter(function (t) {
        return t.allowUserUpload;
      })
      .map(function (t) {
        var e = t.getEditModeParameters();
        return {
          id: t.id,
          fileName: t.vectorName,
          uuid: t.uuid,
          offsetX: e.offsetX,
          offsetY: e.offsetY,
          scaleX: e.scaleX,
          scaleY: e.scaleY,
          angle: e.angle,
        };
      });

  var payload = {
    texts: texts,
    circularTexts: circularsText,
    vectorPlaceholders: vectorObjects,
    id: engraver.currentProduct.id,
    fileName: 'sadasdas-.png',
    sessionId: engraver.getSessionId(),
    clientVersion: '1.0.0',
    imagesParameters: imagesParameters,
    vectorsParameters: vectorsParameters,
  };

  return $.ajax({
    type: 'POST',
    url: 'https://design-prod.medzt.com/api/productfile/generate-auth',
    crossDomain: !0,
    data: payload,
    dataType: 'json',
    headers: { authorization: apiKey },
    error: function (request, status, error) {
      const responseEror = JSON.parse(request.responseText);
      if (responseEror && responseEror.message) {
        alert(responseEror.message);
      }
    },
  });
}

/*$(document).keydown(function (event) {
  if (window.matchMedia("(max-width: 700px)").matches) {
    return;
  }
  if (event.keyCode == 123) {
    // Prevent F12
    return false;
  } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
    // Prevent Ctrl+Shift+I
    return false;
  }
});

$(document).on("contextmenu", function (e) {
  if (window.matchMedia("(max-width: 700px)").matches) {
    return;
  }
  e.preventDefault();
});*/
function actionTabs(className) {
  const divElement = $(`.${className}`);
  let curTab = 0;
  const collectionTab = divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs')
    .children('.tab-collection');

  const boxActionTab = divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs');

  if (collectionTab.width() >= boxActionTab.width()) {
    collectionTab.toggleClass('flex');
    boxActionTab.children('.pf_arrow-next').toggleClass('show-action');
  }
  const tabMenu = divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs')
    .children('.tab-collection')
    .children('.tab-collection-title');
  const tabBar = divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs')
    .children('.tab-collection');
  const tabBarCon = divElement.children('.sixteen.columns');

  let maxTabOffset = tabBarCon.width();
  divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs')
    .children('.pf_arrow-next')
    .on('click', function () {
      if (curTab < tabMenu.length - 1) {
        autoScroll(1);
        tabMenu[++curTab].click();
      }
    });
  divElement
    .children('.sixteen.columns')
    .children('.box-action-tabs')
    .children('.pf_arrow-prev')
    .on('click', function () {
      if (curTab > 0) {
        autoScroll(0);
        tabMenu[--curTab].click();
      }
    });

  // check show button next end prev
  tabBar.width() > boxActionTab.width()
    ? tabBar.addClass('active')
    : tabBar.removeClass('active');

  function autoScroll(direction) {
    let offset = 0;
    let posTab = 0;
    //Direction > 0 scroll right
    if (direction > 0) {
      posTab = tabMenu[curTab + 1].offsetLeft + tabMenu[curTab + 1].clientWidth;
      if (posTab >= maxTabOffset) {
        tabBar.animate(
          {
            scrollLeft: tabMenu[curTab + 1].offsetLeft - tabBar.width() * 0.03,
          },
          500,
        );
        maxTabOffset += offset;
        boxActionTab.children('.pf_arrow-prev').addClass('show-action');
      }
      if (posTab < maxTabOffset) {
        boxActionTab.children('.pf_arrow-prev').removeClass('show-action');
      }
      if (curTab + 1 == tabMenu.length - 1) {
        boxActionTab.children('.pf_arrow-next').removeClass('show-action');
      }
    } else {
      if (tabMenu[curTab - 1].offsetLeft == 0) {
        boxActionTab.children('.pf_arrow-prev').removeClass('show-action');
      }

      tabBar.animate(
        {
          scrollLeft: tabMenu[curTab - 1].offsetLeft - tabBar.width() * 0.03,
        },
        500,
      );
      boxActionTab.children('.pf_arrow-next').addClass('show-action');
    }
  }
  tabMenu.on('click', function () {
    $(this)
      .parent('.tab-collection')
      .children('.tab-collection-title')
      .removeClass('active');
    $(this).addClass('active');
    curTab = Array.from(tabMenu).indexOf(this);
    const slugCollection = $(this).attr('slug-col');
    const parentCollection = $(this)
      .parent()
      .parent()
      .parent('.sixteen.columns');
    parentCollection
      .children('.featured-collection-product')
      .removeClass('active');
    parentCollection
      .children(`.featured-collection-product[slug-col=${slugCollection}]`)
      .addClass('active');
    parentCollection.children(`.collection-shop-all`).removeClass('active');
    parentCollection
      .children(`.collection-shop-all[slug-col=${slugCollection}]`)
      .addClass('active');
  });
}
function getCookieByProduct(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}
const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector('meta[name=viewport]');

  if (el !== null) {
    let content = el.getAttribute('content');
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
      content = content.replace(re, 'maximum-scale=1.0');
    } else {
      content = [content, 'maximum-scale=1.0'].join(', ');
    }

    el.setAttribute('content', content);
  }
};

const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (checkIsIOS()) {
  disableIosTextFieldZoom();
}

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    $('#customily-cart-btn-preview').removeClass('ld-custom');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Fetch cart data on initial page load
  fetchCartData();

  // Fetch cart data after AJAX page navigation (if applicable)
  document.addEventListener('pageshow', function () {
    fetchCartData();
  });

  function fetchCartData() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        const cartCount = $('#header-cart-count-bubble');
        if (cartCount[0]) {
          cartCount[0].innerHTML = data.item_count;
        }
      });
  }
});
const trendingImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="increase 1"> <path id="Vector" d="M15.4516 3.85514L15.1547 6.71657C15.1204 7.03068 14.7351 7.16565 14.5142 6.94479L13.8124 6.24292L9.3926 10.6627C9.11529 10.94 8.62694 10.94 8.34963 10.6627L5.91522 8.22825L1.80224 12.3437C1.6599 12.486 1.47095 12.5597 1.28198 12.5597C1.09302 12.5597 0.904065 12.486 0.761726 12.3437C0.474607 12.0566 0.474607 11.5903 0.761726 11.3007L5.39497 6.66748C5.67227 6.39018 6.16063 6.39018 6.43548 6.66748L8.87235 9.10189L12.7718 5.20241L11.9497 4.38031C11.7264 4.15699 11.8614 3.77171 12.1755 3.73981L15.0369 3.44286C15.275 3.41587 15.4762 3.61711 15.4516 3.85514Z" fill="#8E8E93"/></g></svg>
  `;
const recentImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="clock-circular-outline 1"> <path id="Vector" d="M8 1C4.14014 1 1 4.14014 1 8C1 11.8599 4.14014 15 8 15C11.8599 15 15 11.8599 15 8C15 4.14014 11.8599 1 8 1ZM8 13.4699C4.98379 13.4699 2.53005 11.0162 2.53005 8C2.53005 4.98394 4.98379 2.53005 8 2.53005C11.0162 2.53005 13.4699 4.98394 13.4699 8C13.4699 11.0162 11.0162 13.4699 8 13.4699Z" fill="#8E8E93"/> <path id="Vector_2" d="M8.60589 8.00841V5.07455C8.60589 4.74697 8.34043 4.48151 8.01297 4.48151C7.68541 4.48151 7.41992 4.74697 7.41992 5.07455V8.19786C7.41992 8.20719 7.42222 8.21594 7.42267 8.22527C7.41487 8.38652 7.47042 8.55025 7.59358 8.67343L9.80223 10.8819C10.0339 11.1136 10.4094 11.1136 10.6408 10.8819C10.8723 10.6503 10.8725 10.2748 10.6408 10.0433L8.60589 8.00841Z" fill="#8E8E93"/></g></svg>
  `;
const searchImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="Search"> <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M3.29816 7.21906C3.29816 4.69387 5.34523 2.64679 7.87043 2.64679C10.3956 2.64679 12.4427 4.69387 12.4427 7.21906C12.4427 9.74426 10.3956 11.7913 7.87043 11.7913C5.34523 11.7913 3.29816 9.74426 3.29816 7.21906ZM7.87043 1C4.43574 1 1.65137 3.78437 1.65137 7.21906C1.65137 10.6538 4.43574 13.4381 7.87043 13.4381C9.21931 13.4381 10.4679 13.0087 11.4869 12.2791L13.157 13.9449C13.479 14.266 14.0004 14.2654 14.3215 13.9434C14.6426 13.6214 14.642 13.1001 14.32 12.7789L12.6885 11.1517C13.5642 10.0801 14.0895 8.71091 14.0895 7.21906C14.0895 3.78437 11.3051 1 7.87043 1Z" fill="#8E8E93"/></g></svg>
  `;
let maxRetries = 5;
function getPopularSearch() {
  let popularSearch = window.Searchanise?.preloadedSuggestions;

  if (!popularSearch?.length) {
    popularSearch = localStorage.getItem('popularSearch')
      ? JSON.parse(localStorage.getItem('popularSearch'))
      : '';
    return popularSearch;
  }
  localStorage.setItem(
    'popularSearch',
    JSON.stringify(popularSearch.slice(0, 5)),
  );
  return popularSearch.slice(0, 5);
}
function getRecentSearch() {
  try {
    const recentSearches = localStorage.getItem('search-recent')
      ? JSON.parse(localStorage.getItem('search-recent'))
      : '';
    return Array.isArray(recentSearches)
      ? recentSearches.filter((v) => v && v.trim())
      : [];
  } catch (e) {
    return [];
  }
}
function renderInitialSearch() {
  const popularSearches = getPopularSearch();
  const recentSearches = getRecentSearch();
  let content = `
    ${
      popularSearches?.length
        ? ` <p class="title">Trending Searches</p> <div class='popular-search-wrapper'>
            ${popularSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="popular-search-item">
                ${trendingImg}
                ${item}</a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
    ${
      recentSearches?.length
        ? ` <p class="title">Recent Searches</p> <div class='recent-search-wrapper'>
            ${recentSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="recent-search-item">
                ${recentImg}
                <span>${item}</span></a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
  `;
  $('.app_results_container, .app_results_container-mb').html(content);
  setTimeout(() => {
    const popularSearch = window.Searchanise?.preloadedSuggestions;

    if (popularSearch?.length) {
      localStorage.setItem(
        'popularSearch',
        JSON.stringify(popularSearch.slice(0, 5)),
      );
    }
  }, 1000);
}
function getPersonalizationSearch() {
  const defaultData = {
    recentlyViewedProducts: [],
    recentlyAddedToCartProducts: [],
    recentlyPurchasedProducts: [],
  };
  try {
    const personalization = localStorage.getItem('Personalization');
    return personalization ? JSON.parse(personalization) : defaultData;
  } catch (err) {
    return defaultData;
  }
}
const debounceSearch = (fn, delay = 1000) => {
  let timerId = null;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => fn(...args), delay);
  };
};
const onInputSearch = debounceSearch(handleSearch, 0);
function getSearchResultsFromPreload(searchTemp) {
  const popularSearch = window.Searchanise?.preloadedSuggestions;
  if (!popularSearch?.length) {
    return [];
  }
  return popularSearch
    .filter((p) => p.includes(searchTemp))
    .slice(0, limitSearchResult)
    .map((value) => {
      if (value.split(' ').length > 10) {
        let splitString = value.split(searchTemp);
        if (splitString.length > 1) splitString.shift();
        return splitString.length > 0
          ? `${searchTemp}${splitString[0]}`
          : value;
      }
      return value;
    });
}
function renderResultSearch(res, searchText, items = []) {
  if (!res || !Array.isArray(res.suggestions)) return;
  const search = searchText.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(search, 'gi');

  // Render Suggestions
  const suggestionsHtml = res.suggestions
    .map((item) => {
      const highlightedText = item.replace(re, `<mark>$&</mark>`);
      return `
        <a href="/pages/search-results-page/?q=${encodeURIComponent(
          item,
        )}" 
           class="suggestion-search-item" 
           title="${item}">
          ${searchImg} <span>${highlightedText}</span>
        </a>`;
    })
    .join('');

  // Render  Products
  const productsHtml = items?.length
    ? items
        .map(
          (item) => `
          <a href="${item.link}">
            <img src="${item?.image_link}" alt="${item.title}" />
            <p>${item.title}</p>
          </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions">Suggestions</div>
      ${suggestionsHtml}
      <div class="suggestions ${
        items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  $('.app_results_container-mb').html(content);
  $('.suggestion-search-item').click(function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const formValue = $(this).attr('title');
    const listRecentSearch = getRecentSearch();
    if (!listRecentSearch.includes(formValue)) {
      listRecentSearch.unshift(formValue);
      localStorage.setItem(
        'search-recent',
        JSON.stringify(listRecentSearch.splice(0, 3)),
      );
    }
    window.location.href = href;
  });
}

function renderNotFound(searchText) {
  let content = ` <div class="not-found-wrapper"> <p class="title">Sorry, nothing found for <span>${searchText}</span>.</p> </div>
  `;
  $('.app_results_container-mb').html(content);
}
function renderProducts(res) {
  const productsHtml = res?.items?.length
    ? res?.items
        .map(
          (item) => `
        <a href="${item.link}">
          <img src="${item?.image_link}" alt="${item.title}" />
          <p>${item.title}</p>
        </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions ${
        res?.items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  $('.app_results_container-mb').html(content);
}
async function handleSearch(inputElement) {
  try {
    const baseUrl = 'https://www.searchanise.com/getwidgets';
    const apiKey = '4M1G0o2c6c';

    const personalizationSearchData = getPersonalizationSearch();
    let currentTextSearch = inputElement.val();
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }
    const preloadSearch = getSearchResultsFromPreload(currentTextSearch);
    const lengthPreloadSearch = preloadSearch.length;
    if (lengthPreloadSearch > 0) {
      renderResultSearch({ suggestions: preloadSearch }, currentTextSearch);
    }
    const myParams = {
      api_key: apiKey,
      q: currentTextSearch,
      maxResults: 3,
      startIndex: 0,
      items: true,
      pages: false,
      facets: false,
      categories: false,
      suggestions: true,
      vendors: false,
      tags: false,
      pageStartIndex: 0,
      pagesMaxResults: 0,
      categoryStartIndex: 0,
      categoriesMaxResults: 0,
      suggestionsMaxResults: limitSearchResult,
      vendorsMaxResults: 0,
      tagsMaxResults: 0,
      ...personalizationSearchData,
    };
    const queryString = new URLSearchParams(myParams).toString();
    const rawResponse = await fetch(`${baseUrl}?${queryString}`);
    const res = await rawResponse.json();
    currentTextSearch = inputElement.val();
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }

    if (!res?.suggestions?.length) {
      if (res?.items?.length > 0) {
        renderProducts(res);
      } else if (!lengthPreloadSearch) {
        renderNotFound(currentTextSearch);
      }
    } else {
      if (lengthPreloadSearch < limitSearchResult) {
        const suggestionsRender = [
          ...new Set([...res.suggestions, ...preloadSearch]),
        ].slice(0, limitSearchResult);
        renderResultSearch(
          { suggestions: suggestionsRender },
          currentTextSearch,
          res?.items,
        );
      }
    }
  } catch (e) {
    console.log('error', e);
  }
}

//footer
const limitSearchResult = 10;
$(document).ready(function () {
  $('.footer__content-top .footer-block__details-content a.sub-link').on(
    'click',
    function (event) {
      event.preventDefault();
      $(this).toggleClass('active');
    },
  );

  $(".header__search input[type='search']").click(function () {
    const $parent = $(this).closest('.search_container');
    if (!$(this).val()) {
      $parent.find('.search_results_overlay').show();
      $parent.find('.app_results_container').show();
    }
    renderInitialSearch();
  });

  $('.search-modal__close-button').click(function () {
    $(
      '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
    ).show();
    $('.search-modal').addClass('show');
    renderInitialSearch();
    $('.search_form_mb input').focus();
    if ($('.search_form_mb input').val()) {
      const inputElement = $('.search_form_mb input');
      onInputSearch(inputElement);
    }
  });

  $('.header__search .search_form_mb ,.search.hidden-xs').on(
    'submit',
    function (e) {
      e.preventDefault();
      const formValue = $(this).find('input').val();
      if (formValue && formValue.trim()) {
        const listRecentSearch = getRecentSearch();
        if (!listRecentSearch.includes(formValue)) {
          listRecentSearch.unshift(formValue);
          localStorage.setItem(
            'search-recent',
            JSON.stringify(listRecentSearch.splice(0, 3)),
          );
        }
      }
      const cleanFormValue = encodeURIComponent(formValue);
      window.location.href =
        '/pages/search-results-page/?q=' +
        cleanFormValue;
    },
  );
  $('body').on(
    'input',
    '.header__search.search_container .search__input.field__input',
    function (e) {
      const value = e.target.value;
      if (value) {
        $('.search_results_overlay').hide();
        $('.app_results_container,.closed-modal-search').hide();
      } else {
        $('.search_results_overlay').show();
        $('.app_results_container').show();
        if (!$('.app_results_container .popular-search-item').length) {
          renderInitialSearch();
        }
      }
    },
  );

  $('.search_form_mb input[type="text"]').on('paste', function (e) {
    const inputElement = $(this);
    onInputSearch(inputElement);
  });
  $('body').on('input', '.search_form_mb input[type="text"]', function (e) {
    const inputElement = $(this);
    onInputSearch(inputElement);
  });

  $('.search_results_overlay-mb,.closed-modal-search').click(function () {
    $(
      '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
    ).hide();
    $('.search-modal').removeClass('show');
  });

  var target = $('.grid__item.product__media-wrapper');
  var btnPreview = $('.btn-preview');

  $(window).on('scroll', function () {
    if (
      window.innerWidth > 1024 ||
      (btnPreview && !btnPreview.length) ||
      (target && !target.length)
    )
      return;

    var targetOffset = target.offset().top + target.height();
    var scrollPosition = $(window).scrollTop() + $(window).height();
    if (scrollPosition - 150 >= targetOffset) {
      btnPreview.fadeIn();
      btnPreview.removeClass('hidden');
    } else {
      btnPreview.fadeOut();
      btnPreview.addClass('hidden');
    }
  });
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.header__search.search_container').length) {
    $('.search_results_overlay').hide();
    $('.app_results_container,.closed-modal-search').hide();
  }
});

$(document).on('click', '.more-detail-gift-box', function () {
  $(this).parent().children('img').click();
});

$(document).on('click', '.gift-box-content-img img', function () {
  $(this).parent().toggleClass('modal');
  $('.modal-box').toggleClass('hidden');
  $('body').toggleClass('none-scroll');
});

$(document).on('click', '.cloded-gift-box,.modal-box', function () {
  $('.gift-box-content-img').removeClass('modal');
  $('.modal-box').addClass('hidden');
  $('body').removeClass('none-scroll');
});

// convert size inches to cm size chart
var btnConvertSizeCM = document.querySelectorAll('.btn-size-chart.cm');
var btnConvertSizeIN = document.querySelectorAll('.btn-size-chart.in');

btnConvertSizeCM &&
  btnConvertSizeCM.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-active')) return;
      handleSizeChartCm();
    });
  });
function getListSize(element) {
  const listSize = element.textContent.split('-');
  const size1 = parseFloat(listSize[0].replace('in', '').replace('cm', ''));
  const size2 = parseFloat(listSize[1].replace('in', '').replace('cm', ''));
  const oldValue = `${size1} - ${size2}`;
  return oldValue;
}
function handleSizeChartCm() {
  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.add('is-active');
  });

  const convertToCm = (element) => {
    let oldValue = element.getAttribute('old-value');

    const isManySize = element.textContent.includes("–") || element.textContent.includes("-")

    if (!oldValue) {
      if (isManySize) {
        element.setAttribute('old-value', element.textContent);
      } else {
        oldValue = parseFloat(element.textContent.replace('in', '').replace('cm', ''));
        element.setAttribute('old-value', oldValue);
      }

    }

    if (isManySize) {
      const firstSize = parseFloat(element.textContent.split('–')[0]);
      const secoundSize = parseFloat(element.textContent.split('–')[1].replace('in', '').replace('cm', ''));

      element.textContent = `${(firstSize * 2.54).toFixed(2)} – ${(secoundSize * 2.54).toFixed(2)} cm`;
    } else {
      element.textContent = `${(oldValue * 2.54).toFixed(2)} cm`;
    }
  };

  document
    .querySelectorAll('.wrapper-table table td')
    .forEach(function (element) {
      const text = element.textContent;
      if (text.includes(' in')) {
        convertToCm(element);
      }
    });
  document.querySelectorAll('.data-size-chart-2').forEach(function (element) {
    let oldValue = element.getAttribute('old-value');
    if (!oldValue && element.textContent) {
      oldValue = getListSize(element);
      element.setAttribute('old-value', oldValue);
    }
    const listSize = oldValue.split('-');
    element.textContent = `${(listSize[0] * 2.54).toFixed(1)} - ${(
      listSize[1] * 2.54
    ).toFixed(1)} cm`;
  });

  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.remove('is-active');
  });
}

btnConvertSizeIN &&
  btnConvertSizeIN.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-active')) return;
      handleSizeChartIn();
    });
  });

function handleSizeChartIn() {
  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.add('is-active');
  });
  const convertToInches = (element) => {
    let oldValue = element.getAttribute('old-value');
    const isManySize = element.textContent.includes("–") || element.textContent.includes("-")

    if (!oldValue) {
      oldValue = parseFloat(element.textContent.replace(/in|cm/g, '').trim());
      element.setAttribute('old-value', oldValue);
      if (element.textContent.includes('cm')) {
        oldValue = (oldValue / 2.54).toFixed(2);
      }
    }

    if (isManySize) {
      element.textContent = oldValue;
    } else {
      element.textContent = `${oldValue} in`;
    }
  };

  document.querySelectorAll('.wrapper-table table td').forEach((element) => {
    if (element.textContent.includes(' cm')) {
      convertToInches(element);
    }
  });

  document.querySelectorAll('.data-size-chart-2').forEach(function (element) {
    let oldValue = element.getAttribute('old-value');
    if (!oldValue && element.textContent) {
      oldValue = getListSize(element);
      element.setAttribute('old-value', oldValue);
      element.textContent = `${(size1 / 2.54).toFixed(1)} in - ${(
        size2 / 2.54
      ).toFixed(1)} in`;
    }
    const listSize = oldValue.split('-');
    element.textContent = `${listSize[0]} - ${listSize[1]} in`;
  });

  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.remove('is-active');
  });
}

function setCookieUTM(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
  document.cookie = key + "=" + value + "; path=/; expires=" + expires.toUTCString();
}

document.addEventListener('DOMContentLoaded', function () {
    const showPromotion = getCookieByProduct('showPromotion')

    if (window.location.href.includes('promotion') || showPromotion) {
      $(document).ready(function () {
        if($('body.cart').length > 0 || $('body.index').length > 0 || $('body.page').length > 0){
          return
        }

        $('.header-wrapper').prepend(`
          <div class="promotion-box">
            <div class="page-width">🔔 Final price in cart – auto discount applied.</div>        
          </div>
        `);

        if(!showPromotion){
          setCookieUTM('showPromotion', true, 1)
        }
      });
    }
});